import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import pako from 'pako';
import { format, isValid, parseISO, fromUnixTime } from "date-fns";
import { apiRequest } from '../utils/utils';

export function decrypt(findresponse, flg){
  
  
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
        iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
}



export function decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
        iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;

}
export function commonData() {
    var common = {};
    var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
    var localdata = has_local_data ? decrypt(localStorage.getItem('encdata'), 0) : '';
    var  apiUrl= decryptconfigdata('apiUrl');
    var studioUrl = decryptconfigdata('studioUrl');
    var userAuthKey = has_local_data ? localdata.user_key : '';
    var userId = has_local_data ? localdata.user_id : '';
    var userEmail = has_local_data ? localdata.user_email : '';
    common['userEmail'] = userEmail,
    common['apiUrl'] = apiUrl,
    common['studioUrl'] = studioUrl,
    common['userAuthKey'] = userAuthKey,
    common['userId'] = userId

    return common;
}

export function rawjsonparse(findresponse, flg) {
        return findresponse;
    }

export function decompressjsondata(bufferData){
    // Decompress the gzip data
    const inflatedData = pako.inflate(new Uint8Array(bufferData), { to: 'string' });
    // Handle the decompressed data
    const findResponse = JSON.parse(inflatedData);
    return findResponse;
}

export const getFormattedDate = (
  date,
  formatString = "MMM d, yyyy h:mm a 'IST'"
) => {
   let dateObj;
  
	  // ✅ Timestamp (seconds or milliseconds) — already IST
	  if (!isNaN(Number(date))) {
		const num = Number(date);
		const ms = num > 1e12 ? num : num * 1000;
		dateObj = new Date(ms);
	  }
	  // ✅ String date
	  else {
		dateObj = new Date(date);
	  }
  
	  if (isNaN(dateObj.getTime())) return "-NA-";
  
	  // ✅ Format: Feb 6, 2026 5:05 PM IST
	  const formatted = format(
		dateObj,
		"MMM d, yyyy h:mm a 'IST'"
	  );
	  return formatted
};


const isNAString = (val) => {
	if (typeof val !== "string") return false;
	const v = val.trim().toLowerCase();
	return v === "" || v === "na" || v === "n/a";
};

export const isEmpty = (value) => {
	// null or undefined
	if (value == null) return true;

	// strings
	if (typeof value === "string") {
		return isNAString(value);
	}

	// arrays
	if (Array.isArray(value)) {
		if (value.length === 0) return true;

		// array with objects having only NA values
		return value.every((item) => {
			if (item == null) return true;

			if (typeof item === "object" && item.constructor === Object) {
				return Object.values(item).every(isNAString);
			}

			return false;
		});
	}

	// plain objects
	if (typeof value === "object" && value.constructor === Object) {
		if (Object.keys(value).length === 0) return true;

		return Object.values(value).every(isNAString);
	}

	return false;
};

export const fetchContactDetailsData = async (endpoint, mautic_id) => {
	try {
		const payload = {
			mautic_id
		};
		const data = await apiRequest(
			process.env.REACT_APP_CRM_ADMIN + endpoint,
			"POST",
			payload,
			{},
			true			
		);
		
		return data;
	} catch (error) {
		console.error("Error fetching column definitions:", error);
	}
}




// WEBPACK FOOTER //
// ./src/actions/common.js